import axios from 'axios';

const persistAndRefresh = async (storageKey, grouped, card, wfdb) => {
  if (wfdb?.putItem) {
    await wfdb.putItem(wfdb.STORES.PRODUCTS_NOLAYOUT, {
      sectionKey: storageKey,
      products: grouped,
    });
  }
  if (card?.loadProductsFromStorage) card.loadProductsFromStorage();
};

const nolayoutToStorage = async ({
  collectionHandle,
  handles,
  storageKey,
  card,
  filter,
  firstBurst = 2,
  updateEvery = 3,
  wfdb = window.WFDB,
}) => {
  if (!card || !Array.isArray(handles) || !handles.length) return;

  const existingData = await wfdb.getItem(wfdb.STORES.PRODUCTS_NOLAYOUT, storageKey);
  const THIRTY_MINUTES = 30 * 60 * 1000;
  
  if (existingData && existingData.timestamp && (Date.now() - existingData.timestamp) < THIRTY_MINUTES) {
    console.log('Data is fresh, skipping refetch');
    if (filter) {
      filter.addEventListener('collection_changed', (e) => {
        const col = e?.detail?.collection;
        if (col) {
          card.collection = col;
          card.products = [];
          card.loadProductsFromStorage();
        }
      });
    }
    
    const defaultCol = Object.keys(existingData.products || {}).find(h => (existingData.products[h] || []).length > 0) || Object.keys(existingData.products || {})[0];
    if (defaultCol) card.collection = defaultCol;
    
    card.dataFetchComplete = true;
    return;
  }

  if (filter) {
    filter.addEventListener('collection_changed', (e) => {
      const col = e?.detail?.collection;
      if (col) {
        card.collection = col;
        card.products = [];
        card.loadProductsFromStorage();
      }
    });
  }

  const baseUrl = `${window.location.origin}/collections/${collectionHandle}?view=nolayout.cards`;
  const grouped = Object.fromEntries(handles.filter(Boolean).map((h) => [h, []]));
  const seen = new Set();
  const addProducts = (products = []) => {
    for (const p of products) {
      if (seen.has(p.id)) continue;
      seen.add(p.id);
      const cols = Array.isArray(p.collections) ? p.collections : [];
      for (const h of handles) if (h && cols.includes(h)) grouped[h].push(p);
    }
  };

  let page = 1;
  let hasNext = true;

  while (hasNext && page <= firstBurst) {
    const { data } = await axios.get(baseUrl, { params: { page } });
    addProducts(data?.products || []);
    hasNext = data?.has_next === true;
    page += 1;
  }

  const defaultCol = handles.find((h) => grouped[h]?.length) || handles[0];
  if (defaultCol) card.collection = defaultCol;

  await persistAndRefresh(storageKey, grouped, card, wfdb);

  while (hasNext) {
    const { data } = await axios.get(baseUrl, { params: { page } });
    addProducts(data?.products || []);
    hasNext = data?.has_next === true;
    page += 1;

    if ((page - 1) % updateEvery === 0 || !hasNext) {
      await persistAndRefresh(storageKey, grouped, card, wfdb);
    }
  }

  card.dataFetchComplete = true;
};

window.nolayoutToStorage = nolayoutToStorage;

export default nolayoutToStorage;
